
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IItemVendor } from "@tylertech/tyler-api-types";

/**
 * ItemVendorService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemVendorService {
    constructor(private readonly $apiService: ApiService) { }
    
    DeleteItemVendor(pItemVendorId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IItemVendorService/DeleteItemVendor", pItemVendorId);
    }
    GetItemVendors(pItemId: string): Promise<IItemVendor[]> {
        return this.$apiService.sendAuth("IItemVendorService/GetItemVendors", pItemId);
    }
    SaveItemVendor(pItemVendor: IItemVendor): Promise<IItemVendor> {
        return this.$apiService.sendAuth("IItemVendorService/SaveItemVendor", pItemVendor);
    }
}
